import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdxSegmentPage } from './gdx-segment';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    GdxSegmentPage,
  ],
  imports: [
    IonicPageModule.forChild(GdxSegmentPage),
    FlexLayoutModule,
  ],
  exports: [
    GdxSegmentPage
  ]
})
export class GdxSegmentPageModule {}



// WEBPACK FOOTER //
// ./src/components/gdx-segment/gdx-segment.module.ts